import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile-parent',
    templateUrl: './profile-parent.component.html',
    styleUrls: ['./profile-parent.component.scss'],
    standalone: false
})
export class ProfileParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
